import React, {useState} from "react";
import {auth} from "../../../firebase";
import GoogleLogin from "../googleLogin/googleLogin";
import {validateEmail} from "../../../utils/utils";
import {fetchSignInMethodsForEmail, updateProfile} from 'firebase/auth';
import avatarDefault from "../../../images/avatardefault.png"

function SignIn({setCurrentPage, onFinishLogin}) {

    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState(false);
    const [passConfError, setPassConfError] = useState(false);
    const [validForm, setValidForm] = useState(false);

    const signInUser = (e) => {
        e.preventDefault();
        dismissError();

        auth.createUserWithEmailAndPassword(email, password)
            .then((userCredential) => {
                // User successfully signed in
                const user = userCredential.user;
                onFinishLogin();

                updateProfile(user, {
                    displayName: userName,
                    photoURL: avatarDefault
                });
            })
            .catch((error) => {
                // Handle any errors that occur during sign in
                document.getElementById("loginHomeModal")?.querySelectorAll('input').forEach(x => x.classList.add('is-invalid'))
                setError('error creando la cuenta');
                console.log(error.toString())
                // Handle the error accordingly
            });
    }

    // Función para verificar la existencia del correo electrónico
    const checkEmailExistence = async (email) => {
        try {
            const methods = await fetchSignInMethodsForEmail(auth, email);
            return methods.length > 0; // Si la longitud de los métodos es mayor a 0, el correo electrónico existe
        } catch (error) {
            console.error('Error checking email existence:', error);
            // Manejar el error según sea necesario
        }
    };

    async function getEmailError(input) {
        if (!input.value) {
            setEmailError('');
            return;
        }
        if (!validateEmail(input.value)) {
            setEmailError('Correo electrónico inválido');
        } else {
            checkEmailExistence(input.value).then(res => {
                if (res) {
                    setEmailError('Correo electrónico ya registrado');
                } else {
                    setEmailError('success');
                }
            });
        }
    }

    async function getPasswordError(value) {
        if (!value) {
            setPasswordError(false);
            return;
        }
        if (value.length < 6) {
            setPasswordError(true);
        } else {
            setPasswordError(false);
        }
    }


    async function getPassConfError(value) {
        if (!value) {
            setPassConfError(false);
            return;
        }
        if (value !== password) {
            setPassConfError(true);
        } else {
            setPassConfError(false);
        }
    }

    function validate() {
        //email
        let success = true;
        //password

        const passwordInput = document.getElementById('passwordInput');
        if (passwordInput.value.length < 6) {
            document.getElementById('passwordInput')?.classList.add('is-invalid');
            document.getElementById('confPasswordInput')?.classList.remove('is-invalid');
            success = false;
            setValidForm(success);
            return success;
        } else {
            document.getElementById('passwordInput')?.classList.remove('is-invalid');
        }

        const confPasswordInput = document.getElementById('confPasswordInput');
        if (passwordInput.value !== confPasswordInput.value) {
            document.getElementById('confPasswordInput')?.classList.add('is-invalid');
            success = false;
        } else {
            document.getElementById('confPasswordInput')?.classList.remove('is-invalid');
        }

        setValidForm(success);
        return success;
    }

    function dismissError() {
        setError("");
        document.getElementById("loginHomeModal")?.querySelectorAll('input').forEach(x => x.classList.remove('is-invalid'))
    }

    const colSize = "col-12";

    return (
        <div>
            <div className="col-12 text-center">
                <GoogleLogin onFinishLogin={onFinishLogin}/>
            </div>
            <div className="d-flex flex-row align-items-center col-12 justify-content-center">
                <hr className="col-4 me-3"/>
                <span className="text-center">O</span>
                <hr className="col-4 ms-3"/>
            </div>
            <form className="d-flex flex-row flex-wrap col-12 justify-content-center" autoComplete="false">
                {error && <div className="alert alert-danger alert-dismissible fade show col-7" role="alert">
                    {error}
                    <button type="button" className="btn-close" onClick={() => dismissError()}/>
                </div>}
                <input autoComplete="false" name="hidden" type="text" style={{display: "none"}}/>

                <div className={"form-floating mb-3 " + colSize}>
                    <input id="userInput" onBlur={e => {
                        setUserName(e.target.value);
                    }} autoComplete="false" maxLength="20" placeholder="Nombre de usuario"
                           type="text"
                           className={"form-control " + (userName && " is-valid ")} />
                    <label htmlFor="userInput">Nombre de usuario *</label>
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input id="emailInput" onBlur={e => {
                        setEmail(e.target.value);
                        getEmailError(e.target);
                    }} autoComplete="false"
                           type="email"
                           className={"form-control "
                               + ((email && emailError && emailError !== 'success') && " is-invalid ")
                               + ((email && emailError === 'success') && " is-valid ")}
                           placeholder="Correo electrónico"/>
                    <label htmlFor="emailInput">Email *</label>
                    {(emailError && emailError !== 'success') &&
                        <div className="invalid-feedback">
                            {emailError}
                        </div>}
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input id="passwordInput" onBlur={e => {
                        setPassword(e.target.value);
                        getPasswordError(e.target.value);
                        getPassConfError(confirmPassword);
                    }} autoComplete="new-password" type="password" placeholder="Contraseña"
                           className={"form-control " + (password && ((passwordError) ? "is-invalid" : "is-valid"))}/>
                    <label htmlFor="passwordInput">Contraseña *</label>
                    <small>La contraseña debe tener al menos 6 caracteres</small>
                    <br/>
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input id="confPasswordInput" onChange={e => {
                        setConfirmPassword(e.target.value);
                        getPasswordError(password);
                        getPassConfError(e.target.value);
                    }} autoComplete="new-password" placeholder="Confirmar contraseña" type="password"
                           className={"form-control " + (confirmPassword && (passConfError ? "is-invalid" : "is-valid"))}/>
                    <label htmlFor="confPasswordInput">Confirmar contraseña *</label>
                    {passConfError && <div className="invalid-feedback">
                        Las contraseñas no coinciden
                    </div>}
                </div>
                <div className={"mb-3 " + colSize + " d-flex flex-row align-items-center justify-content-between"}>
                    <button className="btn btn-primary" type="submit" disabled={passConfError || passwordError || !userName || emailError.length > 7} onClick={e => {
                        signInUser(e);
                    }}>Registrarse</button>
                    <small>* campos requeridos</small>
                </div>
                <div className={"mb-3 " + colSize}>
                    <b>¿Ya tienes una cuenta?</b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}} onClick={() => setCurrentPage("login")}>
                        Iniciar sesión
                    </a>
                </div>
            </form>
        </div>
    )
}

export default SignIn;
